<template>
  <div class="team">
    <h2>团队风采</h2>
    <p></p>
    <div class="team-swiper">
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item, index) in team" :key="index">
            <img :src="item[0].image" alt />
            <img :src="item[1].image" alt />
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
export default {
  name: "Team",
  props: {
    teamList: Array,
  },
  data() {
    return {
      swiper: null,
    };
  },
  mounted() {
    this.swiper = new Swiper(".team-swiper .swiper-container", {
      observer: true,
      observeParents: true,
      slidesPerView: 5,
      pagination: {
        el: '.swiper-pagination',
      },
    });
  },
  computed: {
    team() {
      var pages = [];
      for (var i = 0; i < this.teamList.length; i++) {
        const page = Math.floor(i / 2);
        if (!pages[page]) {
          pages[page] = [];
        }
        pages[page].push(this.teamList[i]);
      }
      return pages;
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varible.styl';

.team-swiper {
  display: flex;
  margin-top: 60px;
}

.swiper-wrapper {
  margin: 0 auto;
  height: 100%;
}

.swiper-slide {
  width: 322px !important;
  padding: 0 15px;

  img {
    display: flex;
    width: 322px;
    height: 250px;
    align-items: center;
    margin-bottom: 24px;
  }
}

>>>.swiper-pagination {
  top: 530px;
  left: 0;
  width: 100%;
}

>>>.swiper-pagination-bullet {
  width: 16px;
  height: 6px;
  display: inline-block;
  background: #666666;
  opacity: 0.3;
  margin: 0 5px;
  border-radius: 3px;
}

>>>.swiper-pagination-bullet-active {
  width: 40px;
  opacity: 1;
  background-color: $yellow;
}

.team {
  position: relative;
  padding-top: 80px;
  text-align: center;
  overflow: hidden;
  padding-bottom: 115px;
  max-width: 1920px;
  min-width: 1440px;
  margin: 0 auto;

  h2 {
    text-align: center;
    font-size: 30px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    letter-spacing: 2px;
  }

  >p:first-of-type {
    border-bottom: 1px solid #F5BA1A;
    margin: 24px auto 0;
    width: 42px;
    height: 2px;
  }

  .team-images {
    width: 100%;
    overflow: hidden;
    position: relative;
    z-index: 1;
    padding-bottom: 2%;

    li {
      width: 28%;
      margin-right: 32px;
      margin-bottom: 28px;
      float: left;

      img {
        width: 100%;
        margin-bottom: 5%;
      }
    }

    li:nth-of-type(2n) {
      margin-top: 3%;
    }

    li:first-of-type {
      margin-left: -10%;
    }

    li:last-of-type {
      margin-right: -12%;
    }
  }

  #team-canvas {
    position: absolute;
    bottom: 0;
    left: 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/pc/AboutTeam.vue